import dynamic from "next/dynamic";
const PlatformInteractiveExperienceHomepageFirstFoldComponent = dynamic(()=>import("./platform-interactive-experience-homepage-first-fold-component"));
import PlatformInteractiveExperienceHomepageFirstFoldConfig from "./platform-interactive-experience-homepage-first-fold-config";
import PlatformInteractiveExperienceHomepageFirstFoldAdvancedConfig from "./platform-interactive-experience-homepage-first-fold-advanced-config";
export default {
    PlatformInteractiveExperienceHomepageFirstFoldComponent,
    PlatformInteractiveExperienceHomepageFirstFoldConfig,
    PlatformInteractiveExperienceHomepageFirstFoldAdvancedConfig
};
